import { useAuthStore } from '../store';

/**
 * Hook to access current access token and refresh functionality
 */
export const useAccessToken = () => {
  const accessToken = useAuthStore((state) => state.accessToken);
  const refreshToken = useAuthStore((state) => state.refreshToken);
  
  return { 
    token: accessToken,
    refreshToken 
  };
};
